// We only need to import the modules necessary for initial render
import CoreLayout from '../layouts/CoreLayout/CoreLayout'
import { storeNextRoute, logOutUser } from '../components/Auth'
import SearchRoute from './Search'
import TeamListRoute from './TeamList'
import TeamRoute from './Team'
import TeamUpdateRoute from './TeamUpdate'
import TeamNewRoute from './TeamNew'
import ParticipantRoute from './Participant'
import ParticipantsRoute from './Participants'
import ParticipantNewRoute from './ParticipantNew'
import ParticipantUploadRoute from './ParticipantUpload'
import MembersRoute from './Members'
import MemberRoute from './Member'
import MemberNewRoute from './MemberNew'
import MemberUploadRoute from './MemberUpload'
import TemplateNewRoute from './TemplateNew'
import TemplateNewBundleRoute from './TemplateNewBundle'
import TemplateRoute from './Template'
import TemplatesRoute from './Templates'
import LoginRoute from './Login'
import MemberListRoute from './MemberList'
import ScreeningConfigRoute from './ScreeningConfig'
import TeamLicenseRoute from './TeamLicense'
import ExternalApiDebugRoute from './ExternalApiDebug'
import BillingCodesRoute from './BillingCodes'
import PatientFieldsRoute from './PatientFields'
import ReferralProductsRoute from './ReferralProducts'

const requireAuth = (store) => (nextState, replace) => {
  const state = store.getState()
  if (!(state.auth || {}).isAuthenticated) {
    store.dispatch(logOutUser())
  } else {
    const nextLocation = (state.router.locationBeforeTransitions || {}).pathname
    const nextRoute = nextLocation || '/'
    store.dispatch(storeNextRoute(nextRoute))
  }
  /* const token = localStorage.getItem('id_token')
  let storedRoute = state.auth && state.auth.nextRoute
  if(!(state.auth || {}).isAuthenticated) { // user is authenticated
    store.dispatch(logOutUser());
    if (token) {
      const tokenIsValid = await validateToken(token);
      if(tokenIsValid) { // set logged in state
        store.dispatch(setValidatedTokenLoggedInState(token));
        storedRoute = '/';
      }
      if (storedRoute) {
        replace(storedRoute);
        next(true);
      }
    }
  } else { // user is not authenticated
    const nextLocation = (state.router.locationBeforeTransitions || {}).pathname;
    const nextRoute = nextLocation || '/';
    store.dispatch(storeNextRoute(nextRoute));
  } */
}

export const createRoutes = (store) => ({
  path: '/',
  childRoutes: [
    {
      component: CoreLayout,
      onEnter: requireAuth(store),
      indexRoute: TeamListRoute(store),
      childRoutes: [
        SearchRoute(store),
        TeamNewRoute(store),
        TeamRoute(store),
        ParticipantNewRoute(store),
        ParticipantUploadRoute(store),
        ParticipantRoute(store),
        ParticipantsRoute(store),
        MemberNewRoute(store),
        MemberUploadRoute(store),
        MembersRoute(store),
        MemberRoute(store),
        TeamUpdateRoute(store),
        TemplateNewRoute(store),
        TemplateNewBundleRoute(store),
        TemplateRoute(store),
        TemplatesRoute(store),
        MemberListRoute(store),
        ScreeningConfigRoute(store),
        TeamLicenseRoute(store),
        ExternalApiDebugRoute(store),
        BillingCodesRoute(store),
        PatientFieldsRoute(store),
        ReferralProductsRoute(store)
      ]
    },
    {
      component: CoreLayout,
      childRoutes: [
        LoginRoute(store)
      ]
    }
  ]
})

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js